import { convertJwtToBase64, convertBase64ToObject } from '../../js/utilities/utilities.jwt';
import { getStreamObject } from '../../js/api/getstreamobject';
export async function verifyDRM(playerContext, payload) {
    try {
        const { player, npoplayer: { streamObject, sourceConfig } } = playerContext;
        const { stream } = streamObject;
        if (stream.drmToken) {
            const drmJsonTimestamp = getDRMTokenTimestamp(stream.drmToken);
            const currentTime = Math.trunc(Date.now() / 1000);
            if (drmJsonTimestamp >= currentTime) {
                await player.load(sourceConfig);
                return;
            }
            console.warn('DRM token window verstreken; item wordt herladen met een nieuwe token.');
            await refreshDRMToken(playerContext, payload);
            return;
        }
        await loadPlayer(playerContext, sourceConfig);
    }
    catch (error) {
        console.error(`Error verifying DRM in verifyDRM function: ${error}`);
    }
}
async function loadPlayer(playerContext, sourceConfig) {
    await playerContext.player.load(sourceConfig);
}
function getDRMTokenTimestamp(drmToken) {
    const drmBase64 = convertJwtToBase64(drmToken);
    return convertBase64ToObject(drmBase64).iat;
}
async function refreshDRMToken(playerContext, payload) {
    const backupStreamObject = await getStreamObject(playerContext.npoplayer, payload);
    const newDrmToken = backupStreamObject.stream.drmToken;
    const clonedStreamObject = {
        ...playerContext.npoplayer.streamObject,
        stream: { ...playerContext.npoplayer.streamObject.stream, drmToken: newDrmToken }
    };
    playerContext.npoplayer.streamObject = clonedStreamObject;
    await loadPlayer(playerContext, playerContext.npoplayer.sourceConfig);
}
